import {
    AdditionalCoveragesFilterOption,
    AssistanceConditionsFilterOption,
    CoveragesFilterOption,
    FilterKey,
    FilterType,
    NNWValueFilterOption,
    OffersFilter,
    OwnContributionFilterOption,
    PartsDepreciationFilterOption,
    RepairPartsFilterOption
} from './offers-filter.model';
import {InsuranceCompanyService} from '../../../../../services/insurance-company.service';
import {FiltersDefinitionBase} from './filters-definition-base';

export class FiltersDefinition extends FiltersDefinitionBase {

    constructor(insuranceCompanyService: InsuranceCompanyService) {
        super(insuranceCompanyService, 'OFFER_SECTION.FILTERS_COMPONENT.filters');
    }
    
    createConfig(): OffersFilter[] {
        return [
            {
                key: FilterKey.COVERAGE,
                title: `${this.translationsContainer}.coverage.title`,
                type: FilterType.CHECKBOX,
                options: [
                    {
                        key: CoveragesFilterOption.OC,
                        label: `${this.translationsContainer}.coverage.options.OC`
                    },
                    {
                        key: CoveragesFilterOption.OC_AC_MINI,
                        label: `${this.translationsContainer}.coverage.options.OC_AC_MINI`,
                        tooltip: `${this.translationsContainer}.coverage.optionsTooltips.OC_AC_MINI`
                    },
                    {
                        key: CoveragesFilterOption.OC_AC,
                        label: `${this.translationsContainer}.coverage.options.OC_AC`
                    }
                ],
                initialOptions: []
            },
            {
                key: FilterKey.ADDITIONAL_COVERAGE,
                title: `${this.translationsContainer}.additionalCoverage.title`,
                type: FilterType.CHECKBOX,
                options: [
                    {
                        key: AdditionalCoveragesFilterOption.NNW,
                        label: `${this.translationsContainer}.additionalCoverage.options.NNW`
                    },
                    {
                        key: AdditionalCoveragesFilterOption.ASSISTANCE,
                        label: `${this.translationsContainer}.additionalCoverage.options.ASSISTANCE`
                    },
                    {
                        key: AdditionalCoveragesFilterOption.OTHER_GLASS,
                        label: `${this.translationsContainer}.additionalCoverage.options.OTHER_GLASS`
                    }
                ]
            },
            {
                key: FilterKey.OWN_CONTRIBUTION,
                title: `${this.translationsContainer}.ownContribution.title`,
                type: FilterType.CHECKBOX,
                tooltip: `${this.translationsContainer}.ownContribution.tooltip`,
                options: [
                    // {
                    //     key: OwnContributionFilterOption.ANY_CONTRIBUTION,
                    //     label: `${this.translationsContainer}.ownContribution.options.any`,
                    //     isAnyOption: true
                    // },
                    {
                        key: OwnContributionFilterOption.WITHOUT_OWN_CONTRIBUTION,
                        label: `${this.translationsContainer}.ownContribution.options.withoutOwnContribution`
                    },
                    {
                        key: OwnContributionFilterOption.WITH_OWN_CONTRIBUTION,
                        label: `${this.translationsContainer}.ownContribution.options.withOwnContribution`
                    }
                ],
                initialOptions: []
            },
            {
                key: FilterKey.REPAIR_PARTS,
                title: `${this.translationsContainer}.repairParts.title`,
                type: FilterType.CHECKBOX,
                options: [
                    // {
                    //     key: RepairPartsFilterOption.ANY_REPAIR_PARTS,
                    //     label: `${this.translationsContainer}.repairParts.options.any`,
                    //     isAnyOption: true
                    // },
                    {
                        key: RepairPartsFilterOption.ORIGINAL,
                        label: `${this.translationsContainer}.repairParts.options.original`,
                        tooltip: `${this.translationsContainer}.repairParts.optionsTooltips.original`
                    },
                    {
                        key: RepairPartsFilterOption.REPLACEMENTS,
                        label: `${this.translationsContainer}.repairParts.options.replacements`,
                        tooltip: `${this.translationsContainer}.repairParts.optionsTooltips.replacements`
                    }
                ],
                initialOptions: []
            },
            {
                key: FilterKey.PARTS_DEPRECIATION,
                title: `${this.translationsContainer}.partsDepreciation.title`,
                type: FilterType.CHECKBOX,
                options: [
                    // {
                    //     key: PartsDepreciationFilterOption.ANY_DEPRECIATION,
                    //     label: `${this.translationsContainer}.partsDepreciation.options.any`,
                    //     isAnyOption: true
                    // },
                    {
                        key: PartsDepreciationFilterOption.WITH_DEPRECIATION,
                        label: `${this.translationsContainer}.partsDepreciation.options.withDepreciation`,
                        tooltip: `${this.translationsContainer}.partsDepreciation.optionsTooltips.withDepreciation`
                    },
                    {
                        key: PartsDepreciationFilterOption.WITHOUT_DEPRECIATION,
                        label: `${this.translationsContainer}.partsDepreciation.options.withoutDepreciation`,
                        tooltip: `${this.translationsContainer}.partsDepreciation.optionsTooltips.withoutDepreciation`
                    }
                ],
                initialOptions: []
            },
            {
                key: FilterKey.ASSISTANCE_CONDITIONS,
                title: `${this.translationsContainer}.assistanceConditions.title`,
                type: FilterType.CHECKBOX,
                options: [
                    // {
                    //     key: AssistanceConditionsFilterOption.ANY_ASSISTANCE_CONDITION,
                    //     label: `${this.translationsContainer}.assistanceConditions.options.any`,
                    //     isAnyOption: true
                    // },
                    {
                        key: AssistanceConditionsFilterOption.ACCIDENT,
                        label: `${this.translationsContainer}.assistanceConditions.options.accident`
                    },
                    {
                        key: AssistanceConditionsFilterOption.BREAKDOWN,
                        label: `${this.translationsContainer}.assistanceConditions.options.breakdown`
                    },
                    {
                        key: AssistanceConditionsFilterOption.POLAND,
                        label: `${this.translationsContainer}.assistanceConditions.options.poland`
                    },
                    {
                        key: AssistanceConditionsFilterOption.EUROPE,
                        label: `${this.translationsContainer}.assistanceConditions.options.europe`
                    },
                    {
                        key: AssistanceConditionsFilterOption.ACCIDENT_REPLACEMENT_CAR,
                        label: `${this.translationsContainer}.assistanceConditions.options.accidentReplacementCar`
                    },
                    {
                        key: AssistanceConditionsFilterOption.BREAKDOWN_REPLACEMENT_CAR,
                        label: `${this.translationsContainer}.assistanceConditions.options.breakdownReplacementCar`
                    }
                ],
                initialOptions: []
            },
            {
                key: FilterKey.NNW_VALUE,
                title: `${this.translationsContainer}.nnwValue.title`,
                type: FilterType.CHECKBOX,
                enabled: false,
                options: [
                    // {
                    //     key: NNWValueFilterOption.ANY_NNW_VALUE,
                    //     label: `${this.translationsContainer}.nnwValue.options.any`,
                    //     isAnyOption: true
                    // },
                    {
                        key: NNWValueFilterOption.UNDER_20,
                        label: `${this.translationsContainer}.nnwValue.options.under20`
                    },
                    {
                        key: NNWValueFilterOption.FROM_20_TO_40,
                        label: `${this.translationsContainer}.nnwValue.options.from20to40`
                    },
                    {
                        key: NNWValueFilterOption.ABOVE_40,
                        label: `${this.translationsContainer}.nnwValue.options.above40`
                    }
                ],
                initialOptions: []
            },
            {
                key: FilterKey.INSURANCE_COMPANY,
                title: `${this.translationsContainer}.insuranceCompany.title`,
                type: FilterType.CHECKBOX,
                options: [
                    // {
                    //     key: 'ALL_INSURANCE_COMPANIES',
                    //     label: `${this.translationsContainer}.insuranceCompany.options.all`,
                    //     isAnyOption: true
                    // },
                    ...this.createInsuranceCompaniesOptions()
                ],
                initialOptions: []
            },
        ];
    }
}

